import { FCX } from "@datassential/platform-ui-lib";
import { IRecommendedChart } from "@models/RecommendedCharts";
import cn from "classnames";
import { Link } from "react-router-dom";
import { useCallback } from "react";
import http from "@core/fetch";
import { toast } from "react-toastify";
import Skeleton from "@components/Skeleton";

const RecommendedCharts: FCX<{
    data: IRecommendedChart[];
    isExpanded: boolean;
    isLoading?: boolean;
}> = ({
    data,
    isExpanded,
    isLoading,
    className,
}) => {
    const downloadReport = useCallback(
        (downloadLink: string) => {
            toast.info('Preparing your download...');
            http.downloadFileXHRFromUrl('GET', downloadLink)
                .then(() => {
                    toast.success('Report downloaded successfully');
                })
                .catch(() => {
                    toast.error('Failed to download report');
                });
        },
        []
    );

    return (
        <div className={cn(
            "RecommendedCharts",
            !isExpanded && 'is-collapsed',
            className,
        )}>
            {isLoading && new Array(16).fill(null).map((_, index) => (
                <div className="RecommendedCharts__item is-loader">
                    <Skeleton key={index} height={22}/>
                </div>
            ))}
            {!isLoading && data.map((item, index) => {
                const props = {
                    key: item.title,
                    className: cn(
                        "RecommendedCharts__item",
                        !!item.link && 'is-link',
                    ),
                    title: `${item.title} (${item.typeLabel})`,
                    'data-testid': `buttonFoodChartsItemLink-${index}`
                };
                const titleContent = (
                    <>
                        <div
                            className="RecommendedCharts__item-title"
                            data-testid={`textFoodChartsItemTitle-${index}`}
                        >
                            {item.title}
                        </div>
                        <div
                            className="RecommendedCharts__item-subtitle"
                            data-testid={`textFoodChartsItemSubtitle-${index}`}
                        >
                            ({item.typeLabel})
                        </div>
                        {(item.downloadOptions ?? []).map(i => (
                            <button
                                key={i.title}
                                className="RecommendedCharts__item-button"
                                onClick={() => downloadReport(i.url)}
                            >
                                {i.title}
                            </button>
                        ))}
                    </>
                );

                if (!item.link) {
                    return (
                        <div {...props}>
                            {titleContent}
                        </div>
                    );
                }

                return (
                    <Link
                        {...props}
                        to={item.link}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {titleContent}
                    </Link>
                );
            })}
        </div>
    );
};

export default RecommendedCharts;
